import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './consent.css';
import { ANALYTICS_HOSTS, createAnalytics } from './analytics.js';

const control = document.getElementById('cookie-settings');
const production = ANALYTICS_HOSTS.includes(location.hostname);
const preview = control?.dataset.preview === 'true';
// Render the banner locally too, but only send analytics on the public domain.
const analytics = production && !preview ? createAnalytics() : null;
const syncConsent = () => analytics?.setConsent(CookieConsent.acceptedCategory('analytics'));

if (control && !preview) {
  control.hidden = false;
  control.addEventListener('click', () => CookieConsent.showPreferences());
  window.addEventListener('portfolio:route', () => analytics?.pageView());
  CookieConsent.run({
    mode: 'opt-in', revision: 1, hideFromBots: false,
    cookie: { name: 'cc_cookie', expiresAfterDays: 182, sameSite: 'Lax' },
    guiOptions: {
      consentModal: { layout: 'box', position: 'bottom right', equalWeightButtons: true },
      preferencesModal: { layout: 'box', equalWeightButtons: true },
    },
    onConsent: syncConsent,
    onChange: syncConsent,
    categories: {
      necessary: { enabled: true, readOnly: true },
      analytics: {
        enabled: false,
        autoClear: { cookies: [{ name: /^_ga(?:_|$)/ }] },
      },
    },
    language: {
      default: 'en',
      translations: {
        en: {
          consentModal: {
            title: 'A little about cookies',
            description: 'With your permission, dvilladsen.com uses Google Analytics to understand which pages visitors enjoy and how they use this portfolio. Analytics is optional and stays off unless you accept. You can change your mind anytime in Cookie settings.',
            acceptAllBtn: 'Accept analytics',
            acceptNecessaryBtn: 'Reject analytics',
            showPreferencesBtn: 'Cookie settings & details',
          },
          preferencesModal: {
            title: 'Cookie settings & privacy',
            acceptAllBtn: 'Accept analytics',
            acceptNecessaryBtn: 'Reject analytics',
            savePreferencesBtn: 'Save preferences',
            closeIconLabel: 'Close cookie settings',
            sections: [
              {
                title: 'Your choice',
                description: 'dvilladsen.com uses this information to understand visits to this photography portfolio. Analytics runs only with your consent. Rejecting it does not affect access to the site. Use Cookie settings at any time to withdraw consent; this stops future collection and clears Analytics cookies in this browser. Withdrawal does not delete information already collected by Google.',
              },
              {
                title: 'Essential preferences', linkedCategory: 'necessary',
                description: 'The first-party cc_cookie remembers your consent choices for 182 days. The site also stores your chosen gallery size locally on your device. These preferences are not used for analytics.',
              },
              {
                title: 'Google Analytics', linkedCategory: 'analytics',
                description: 'Google Analytics receives page views, interactions, and browser/device information to produce usage reports. Google processes network information, including your IP address, when receiving requests. Data may be processed outside your country, including in the United States. This integration disables Google signals and advertising personalization. See <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google’s privacy policy</a> and <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">how Google uses information from partner sites</a>.',
                cookieTable: {
                  headers: { name: 'Cookie', description: 'Purpose', duration: 'Duration' },
                  body: [
                    { name: '_ga', description: 'Google Analytics visitor identifier', duration: '182 days, renewed with use' },
                    { name: '_ga_*', description: 'Google Analytics session information', duration: '182 days, renewed with use' },
                  ],
                },
              },
            ],
          },
        },
      },
    },
  });
}
